const UAE = () => {
  return (
    <svg
      width="38"
      style={{ transform: "scale(0.8)" }}
      height="28"
      viewBox="0 0 38 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_5839_108262" maskUnits="userSpaceOnUse" x="0" y="0" width="38" height="28">
        <path
          d="M0 2.42871C0 1.32414 0.89543 0.428711 2 0.428711H36C37.1046 0.428711 38 1.32414 38 2.42871V25.5716C38 26.6761 37.1046 27.5716 36 27.5716H2C0.89543 27.5716 0 26.6761 0 25.5716V2.42871Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5839_108262)">
        <path
          d="M0 2.42871C0 1.32414 0.89543 0.428711 2 0.428711H36C37.1046 0.428711 38 1.32414 38 2.42871V25.5716C38 26.6761 37.1046 27.5716 36 27.5716H2C0.89543 27.5716 0 26.6761 0 25.5716V2.42871Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8574 9.47678H38.0003V0.428711H10.8574V9.47678Z"
          fill="#12833B"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8574 27.5715H38.0003V18.5234H10.8574V27.5715Z"
          fill="#262626"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 27.5716H10.8571V0.428711H0V27.5716Z"
          fill="#FF323E"
        />
      </g>
    </svg>
  );
};

export default UAE;
